import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import apis from '@src/apis';
import { validateUserPackageCanUseVoiceCloning } from '@src/services/voiceCloning';
import RequestDashboard from './RequestDashboard';
import NewHomePage from './NewHomePage';
import OldHome from './OldHome';

const Home = () => {
  const [isHasRequest, setIsHasRequest] = useState(false);

  const { user } = useSelector((state) => state.auth);
  const { ttsUser } = useSelector((state) => state.user);

  const { getFeatureValue } = useFeatureFlags();

  const isNewHomepage = getFeatureValue(FEATURE_KEYS.NEW_HOMEPAGE, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });
  const isShowInfoVCRequest =
    getFeatureValue(FEATURE_KEYS.VOICE_CLONING, {
      userId: user?.id,
      email: user.email,
      phoneNumber: user.phoneNumber,
    }) || validateUserPackageCanUseVoiceCloning(ttsUser);
  const isNewHomePageRequest = getFeatureValue(
    FEATURE_KEYS.NEW_HOMEPAGE_REQUEST,
    {
      userId: user.id,
      email: user.email,
      phoneNumber: user.phoneNumber,
    },
  );

  const checkListRequest = async () => {
    try {
      const res = isShowInfoVCRequest
        ? await apis.requests.getRequestsV2()
        : await apis.requests.getRequests();
      const data = res.json();
      return data?.length !== 0;
    } catch (err) {
      return false;
    }
  };

  useEffect(() => {
    setIsHasRequest(checkListRequest());
  }, []);

  const Homepage = () => (isNewHomepage ? <NewHomePage /> : <OldHome />);

  return isHasRequest && isNewHomePageRequest ? (
    <RequestDashboard />
  ) : (
    <Homepage />
  );
};

export default Home;
